import { type FunctionComponent, useState } from 'react';

import { captureException } from '@sentry/react';

import MessageModal from 'components/admin/MessageModal';

import { removeResearchLibCategory } from 'services/researchLib';

import { useGlobalStateObject } from 'utils';

type PropsT = {
  catId: string;
  onClose: () => void;
};

export const RemoveCategoryModal: FunctionComponent<PropsT> = ({
  catId,
  onClose,
}) => {
  const [busy, setBusy] = useState(false);

  const gs = useGlobalStateObject();

  return (
    <MessageModal
      busy={busy}
      cancelButtonLabel="No, cancel"
      confirmButtonLabel="Yes, remove"
      icon="WARN"
      onCancel={onClose}
      onConfirm={() => {
        void (async () => {
          try {
            setBusy(true);

            await removeResearchLibCategory(catId);

            let list = gs.get('researchLib.categories.data');
            if (!list) throw Error('Internal error');

            const idx = list.findIndex((item) => item.id === catId);
            if (idx < 0) throw Error('Internal error');

            list = [...list];
            list.splice(idx, 1);
            gs.set('researchLib.categories.data', list);

            onClose();
          } catch (error) {
            captureException(error);

            // eslint-disable-next-line no-alert
            alert('Failed to remove the category');
          } finally {
            setBusy(false);
          }
        })();
      }}
    >
      <h1>Are you sure you want ot remove this category?</h1>
      <p>This action cannot be undone.</p>
    </MessageModal>
  );
};
